// import { CameraChannel } from '../Interfaces/CameraChannel';
import { defineStore } from 'pinia';
// import Websocket_exam from '../Pages/Exams/Exam/websocket'
// import { QuestionOption } from '../Interfaces/QuestionOption';
// import { usePage } from '@inertiajs/vue3'

export const configFirstLicenseStore = defineStore('common', {
	state: () => ({
		show_button_continue: <boolean>false,
		show_button_error: <boolean>false,
		state: <string>'',
		webcam_configured: <boolean>false,
		mic_configured: <boolean>false,
		error_message: <string>'',
		error: <boolean>false,
		average: <number>0,
	}),
	getters: {
		get_show_button_continue(): Boolean {
			return this.show_button_continue;
		},
		get_show_button_error(): Boolean {
			return this.show_button_error;
		},
		get_state(): String {
			return this.state;
		},
		get_webcam_configured(): Boolean {
			return this.webcam_configured;
		},
		get_mic_configured(): Boolean {
			return this.mic_configured;
		},
		get_error_message(): String {
			return this.error_message;
		},
		get_has_error(): Boolean {
			return this.error;
		},
		get_average(): Number {
			return this.average;
		},
	},
	actions: {
		set_show_button_continue(status_button: boolean) {
			return (this.show_button_continue = status_button);
		},
		set_show_button_error(status_button: boolean) {
			this.show_button_error = status_button;
		},
		set_state(state: string) {
			this.state = state;
		},
		set_webcam_configured(state: boolean) {
			this.webcam_configured = state;
		},
		set_mic_configured(state: boolean) {
			this.mic_configured = state;
		},
		set_error_message(message: string) {
			this.error_message = message;
		},
		set_has_error(state: boolean) {
			this.error = state;
		},
		set_average(number: number) {
			this.average = number;
		},
		async start_verification() {
			const config_webcam = {
				width: 420,
				height: 350,
				image_format: 'jpeg',
				jpeg_quality: 100,
			};
			// @ts-ignore
			await window.Webcam.set(config_webcam);
			// @ts-ignore
			window.Webcam.attach('#box-photo', true);
			// @ts-ignore
			window.Webcam.on('load', function () {});
			this.set_show_button_continue(true);
		},
		start_mic() {
			navigator.mediaDevices
				.getUserMedia({
					audio: true,
				})
				.then((stream) => {
					const video = document.querySelector('audio');
					if (video === null) {
						throw new Error();
					}
					video.srcObject = stream;
					video.onloadedmetadata = () => {
						video.play();
						this.set_mic_configured(true);
						this.verify_mic_working(stream);
					};
				})
				.catch((err) => {
					console.error(err);
				});
		},
		verify_mic_working(stream) {
			const audioContext = new AudioContext();
			const analyser = audioContext.createAnalyser();
			const microphone = audioContext.createMediaStreamSource(stream);
			const scriptProcessor = audioContext.createScriptProcessor(
				2048 / 8,
				1,
				1
			);

			analyser.smoothingTimeConstant = 0.8;
			analyser.fftSize = 1024;

			microphone.connect(analyser);
			analyser.connect(scriptProcessor);
			scriptProcessor.connect(audioContext.destination);
			scriptProcessor.onaudioprocess = () => {
				const array = new Uint8Array(analyser.frequencyBinCount);
				analyser.getByteFrequencyData(array);
				const arraySum = array.reduce((a, value) => a + value, 0);
				var average = (arraySum / array.length) * 15;

				this.set_average(average);
			};
		},
		async start_webcam() {
			const options = {
				width: 320 / 1.5,
				height: 240 / 1.5,
				image_format: 'jpeg',
				jpeg_quality: 100,
			};
			//@ts-ignore
			window.Webcam.set(options);
			//@ts-ignore
			window.Webcam.attach('#camera');
		},
	},
});
